import { CornerRadiusModel } from '@common/models';
import { createFetchProductsHook } from '@core/utils/createFetchProductsHook';

import { useFetchCornerRadiiQuery } from '../cornerRadiiService';

type useCornerRadiiReturn = ReturnType<typeof _useCornerRadii> & {
    cornerRadii: CornerRadiusModel[];
    isFetchingCornerRadii: boolean;
    isErrorCornerRadii: boolean;
};

const emptyArray = [] satisfies CornerRadiusModel[];

const _useCornerRadii = createFetchProductsHook({
    apiQueryHook: useFetchCornerRadiiQuery,
});

export const useCornerRadii = (): useCornerRadiiReturn => {
    const { cornerRadii, ...rest } = _useCornerRadii({
        selectFromResult: (result) => {
            return {
                cornerRadii: result.isError || !result.data ? emptyArray : result.data,
                ...result,
            };
        },
    });

    return {
        cornerRadii,
        isFetchingCornerRadii: rest.isFetching,
        isErrorCornerRadii: rest.isError,
        ...rest,
    };
};
